import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountClient, AccountDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-account-control',
  templateUrl: './account-control.component.html',
  styleUrls: ['./account-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AccountControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AccountControlComponent),
      multi: true,
    }
  ]
})
export class AccountControlComponent extends BaseAutocompleteControl<AccountDto> implements OnInit {

  @Input() accountId: string = '';
  @Input() allowLoadDefault: boolean = true;

  constructor(private accountClient: AccountClient, private cache: AutocompleteCacheService) {
    super();
  }

  ngOnInit(): void {
    // Load default account before initializing filtering
    if (this.accountId) {
      this.accountClient.detail(this.accountId).subscribe(
        account => {
          this.control.setValue(account, { emitEvent: false });
          this.selectedItem = account;
        },
        error => console.error('Error loading account by ID:', error)
      );
    } else if (this.allowLoadDefault) {
      this.accountClient.currentAccount().subscribe(
        account => {
          this.control.setValue(account, { emitEvent: false });
          this.selectedItem = account;
        },
        error => console.error('Error loading current account:', error)
      );
    }

    super.ngOnInit();
  }

  protected fetchItems(searchValue: string): Observable<AccountDto[]> {
    const cacheKey = `accounts_search_${searchValue}`;
    return this.cache.wrap(cacheKey, this.accountClient.getAccountByKeySearch(searchValue).pipe(
      map(items => items || [])
    ));
  }

  getDisplayValue(item: AccountDto | null): string {
    return item?.fullName || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof AccountDto;
  }
}
